import styled from "styled-components";

export const WrapperAsk = styled.div`
  margin: 75px 0;
`;

